import { Component } from '@angular/core';
import { CXoneVoiceContact } from '@nice-devone/acd-sdk';
import { CXoneAuth } from '@nice-devone/auth-sdk';
import { LoggerService } from 'src/app/core/services/logger.service';
import { LoginService } from 'src/app/core/services/login.service';
import { SdkAcdAgent } from 'src/app/data/CXOne/sdk-acd/sdk-acd.service';
import { NiceSdkAuthenticationService } from 'src/app/data/CXOne/sdk-auth/nice-sdk-authentication.service';
import {
  DynamicsGerentePfService,
  TemplateValuesChannelProviderGerentesPF,
} from 'src/app/data/Dynamics/gerentes-pf/dynamics-gerente-pf.service';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { CreateSessionGerentePf } from 'src/app/shared/models/gerente-pf/createSessionGerentePf';
import { CreateTicketGerentePf } from 'src/app/shared/models/gerente-pf/createTicketGerentePf';
import { environment } from 'src/environments/environment';
import { CXonePopUrl } from '@nice-devone/common-sdk';
import { ContactCenterGerentesPFService } from 'src/app/data/CXOne/services/contact-center-gerentes-pf.service';
import {
  DigitalSessionDirection,
  DigitalSessionEventDTO,
  DigitalSessionEventType,
} from '../pessoa-fisica/domain/ContactCenter/DigitalSessionEventDTO';
import { GerentesPFSessionDataDTO } from 'src/app/data/Dynamics/gerentes-pf/GerentesPFSessionDataDTO';
import { TicketCreationRequestControlService } from 'src/app/shared/services/ticket-creation-request-control.service';
import { CIFDatadogService } from 'src/app/shared/services/cif-datadog';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';

@Component({
  selector: 'app-gerente-pf',
  standalone: true,
  imports: [],
  templateUrl: './gerente-pf.component.html',
  styleUrl: './gerente-pf.component.css',
})
export class GerentePfComponent {
  loggerTag: string = 'GERENTE PF ';
  loggerTagDynamics: string = 'DYNAMICS ';
  cxoneAuth: CXoneAuth;
  private channelProviderVariables: TemplateValuesChannelProviderGerentesPF | null =
    null;
  private pendingPopUrls = new Map<string, CXonePopUrl>();
  constructor(
    private logger: LoggerService,
    private loginService: LoginService,
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private dynamics: DynamicsGerentePfService,
    private eventHandler: EventHandlerService,
    private ticketCreationRequestControlService: TicketCreationRequestControlService,
    private contactCenterGerentesPFService: ContactCenterGerentesPFService,
    private cifDatadogService: CIFDatadogService,
    private localStorageUtils: LocalStorageUtils,
    private jsonConverterUtils: JsonConverterUtils,
  ) {
    this.cxoneAuth = CXoneAuth.instance;
  }

  async ngOnInit() {
    this.logger.info(this.loggerTag + '- inicializado');
    const centralId =
      this.localStorageUtils.safeGetItem('centralId') || 'civics';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';
    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );

      if (!isAuthenticated) {
        this.logger.info(this.loggerTag + 'Usuário não autenticado');
        return;
      }
      this.logger.info(
        this.loggerTag + 'Usuário autenticado, inicilizando serviços.',
      );
      await this.niceSdkAuthService.launchAgent();

      await this.sdkAcdAgent.initialize();
      await this.contactCenterGerentesPFService.initializer();
      await this.dynamics.initialize(environment.cif_versao_2_gerentes_pf);

      this.channelProviderVariables = await this.dynamics.loadTemplateValues();

      if (!this.channelProviderVariables) {
        this.logger.error(
          this.loggerTag + 'Erro ao carregar env do CIFramework',
          this.channelProviderVariables,
        );
        return;
      }

      this.logger.info(
        this.loggerTagDynamics + 'Adicionando handler de troca de sessão.',
      );

      var input: CreateSessionGerentePf = {
        templateName: this.channelProviderVariables?.templateSessaoPadrao,
        templateParameters: {},
        context: {
          sessaobeta: true,
        },
      };

      // listagem de tickets associado ao input

      await this.dynamics.cifCreateSession(input, null, '');

      this.sdkAcdAgent.voiceContactUpdate$.subscribe(
        async (voiceContact: CXoneVoiceContact) => {
          const status = voiceContact.status || '';
          const contactId = voiceContact.contactID || '';
          const eventContact = { id: contactId, status: status };

          const processedEvent = this.eventHandler.isProcessed(eventContact);

          this.logger.info(
            this.loggerTag + `(ACD) Voice Contact status : ${status} | evento`,
            voiceContact,
          );

          // devemos criar ticket quando o contato não for inboud??
          if (!voiceContact.isInbound) {
            this.logger.info(
              this.loggerTag + 'Contato não é inbound, ticket não será criado.',
            );
            return;
          }

          if (status === VoiceContactStatusAgent.ACTIVE && !processedEvent) {
            this.eventHandler.add(eventContact);
            await this.processVoiceContactEvent(voiceContact);
          }

          if (status === VoiceContactStatusAgent.DISCONNECTED) {
            this.eventHandler.remove(eventContact);
            const sessionId = this.localStorageUtils.safeGetItem(
              voiceContact.contactID,
            );

            if (!sessionId) {
              this.logger.info(
                this.loggerTag +
                  '- sessionId não encontrado no localStorage, não é possível encerrar',
                voiceContact.contactID,
              );
              return;
            }

            const context = {
              itau_cliente_on: false,
              itau_sessao_ativa: false,
            };

            this.logger.info(this.loggerTag + '- encerrando sessão', sessionId);

            await this.dynamics.cifCloseSession(
              this.channelProviderVariables?.templateAusente ?? '',
              context,
              sessionId,
              contactId,
              'voice',
            );

            this.localStorageUtils.safeRemoveItem(voiceContact.contactID);
            this.localStorageUtils.safeRemoveItem(sessionId);
          }
        },
      );

      this.contactCenterGerentesPFService.onDigitalSessionEvent$.subscribe(
        async (digitalContact) => {
          switch (digitalContact.SessionEventType) {
            case DigitalSessionEventType.Assigned: {
              if (
                digitalContact.SessionDirection ===
                DigitalSessionDirection.Inbound
              ) {
                this.onDigitalEventReceived(digitalContact);
              }
              break;
            }

            case DigitalSessionEventType.Unassigned: {
              if (
                digitalContact.SessionDirection ===
                DigitalSessionDirection.Inbound
              ) {
                this.OnDigitalSessionEnded(digitalContact);
              }
              break;
            }
          }

          this.contactCenterGerentesPFService.onFocusEvent$.subscribe(
            (FocusEvent) => {
              this.logger.info(
                'Solicitação de foco recebida: ',
                JSON.stringify(FocusEvent),
              );

              this.localStorageUtils.safeSetItem(
                'interactionFocused',
                FocusEvent.Id,
              );
              this.dynamics.changeSessionFocus(FocusEvent.Id);
            },
          );
        },
      );
    } catch (error) {
      this.logger.error(this.loggerTag + '- erro autenticar usuário', error);
    }
  }

  private async processVoiceContactEvent(
    voiceContact: CXoneVoiceContact,
  ): Promise<void> {
    try {
      if (typeof (window as any).Microsoft === 'undefined') {
        this.logger.warn(
          'Função microsoft.Microsoft.Cif ainda não está disponível.',
        );
        return;
      }

      const attachdata = this.sdkAcdAgent.deserializeScreenPopUrl(
        voiceContact.screenPopUrl,
      );

      this.cifDatadogService.openTicket.initialData({
        attachData: attachdata,
        mediaType: 'voice',
        masterId: voiceContact.contactID,
      });

      let attachJson = JSON.stringify(attachdata.u_json);
      attachJson = this.jsonConverterUtils.JsonParsed(attachJson);
      const datacb: CreateTicketGerentePf = {
        itau_name: attachdata.itau_name,
        itau_mst_attachdata: attachJson,
        'itau_u_lk_projeto@odata.bind': attachdata.itau_u_lk,
        itau_u_nomeprojeto: attachdata.itau_u_nomeprojeto,
        itau_st_id_conexao: voiceContact.contactID,
        iresolve_st_plugin: attachdata.itau_name,
        itau_u_display: this.channelProviderVariables?.negocio ?? 'juridico',
      };

      this.logger.info(this.loggerTag + 'Dados do ticket', datacb);

      const result = await this.dynamics.cifCreateTicket(
        datacb,
        'voice',
        voiceContact.contactID,
      );

      if (!result || !result.id_interacao || !result.id_ticket) {
        this.logger.error(this.loggerTag + '- Erro   ', result);
        return;
      }

      const input: CreateSessionGerentePf = {
        templateName: this.channelProviderVariables?.templateCreateSession,
        templateParameters: {
          id_interacao: result.id_interacao,
          id_ticket: result.id_ticket,
        },
      };

      this.logger.info(this.loggerTag + '- Criando sessão', input);

      // abre uma aba do ticket e salva o sessionID no localStorage

      const sessionId = await this.dynamics.cifCreateSession(
        input,
        'voice',
        voiceContact.contactID,
      );
      this.localStorageUtils.safeSetItem(voiceContact.contactID, sessionId);
      this.localStorageUtils.safeSetItem(sessionId, voiceContact.contactID);
      this.logger.info(
        this.loggerTag + '- fluxo de ticket executado com sucesso',
        result,
      );
    } catch (error) {
      this.eventHandler.remove({ id: voiceContact.contactID, status: '' });
      this.logger.error('- Erro ao processar contato de voz: ', error);
    }
  }

  private async onDigitalEventReceived(
    digitalSessionEvent: DigitalSessionEventDTO,
  ) {
    try {
      this.logger.info(
        `GERENTES PF (DIGITAL) - evento recebido: `,
        digitalSessionEvent,
      );

      const alreadyHasRequest =
        this.ticketCreationRequestControlService.checkTicketRequest(
          digitalSessionEvent.Id,
        );

      if (alreadyHasRequest) {
        this.logger.info(
          `Já existe uma solicitação de ticket para o evento digital: ${digitalSessionEvent.Id}`,
        );
        this.cifDatadogService.openTicket.request.duplicated({
          masterId: digitalSessionEvent.Id,
          attachData: digitalSessionEvent.AttachData,
          mediaType: digitalSessionEvent.mediaType,
        });
        return;
      }

      this.ticketCreationRequestControlService.saveTicketRequest(
        digitalSessionEvent.Id,
      );

      const attachdata = digitalSessionEvent.AttachData;

      this.cifDatadogService.openTicket.initialData({
        attachData: attachdata,
        mediaType: 'voice',
        masterId: digitalSessionEvent.Id,
      });

      let attachJson = JSON.stringify(attachdata.U_JSON);
      //attachJson = this.jsonConverterUtils.JsonParsed(attachJson);
      const datacb: CreateTicketGerentePf = {
        itau_name: attachdata.ITAU_NAME,
        itau_mst_attachdata: attachJson,
        'itau_u_lk_projeto@odata.bind': attachdata.ITAU_U_LK,
        itau_u_nomeprojeto: attachdata.ITAU_U_NOMEPROJETO,
        itau_st_id_conexao: digitalSessionEvent.Id,
        iresolve_st_plugin: attachdata.ITAU_NAME,
        itau_u_display: this.channelProviderVariables?.negocio ?? 'juridico',
      };

      this.logger.info(this.loggerTag + 'Dados do ticket', datacb);

      const result = await this.dynamics.cifCreateTicket(
        datacb,
        digitalSessionEvent.mediaType,
        digitalSessionEvent.contactId!,
      );

      if (!result || !result.id_interacao || !result.id_ticket) {
        this.logger.error(this.loggerTag + '- Erro   ', result);
        return;
      }

      const input: CreateSessionGerentePf = {
        templateName: this.channelProviderVariables?.templateCreateSession,
        templateParameters: {
          id_interacao: result.id_interacao,
          id_ticket: result.id_ticket,
        },
      };

      this.logger.info(this.loggerTag + '- Criando sessão', input);

      // abre uma aba do ticket e salva o sessionID no localStorage

      const sessionId = await this.dynamics.cifCreateSession(
        input,
        digitalSessionEvent.mediaType,
        digitalSessionEvent.contactId!,
      );

      //Informações usadas na troca de abas do Dynamics
      const sessionData: GerentesPFSessionDataDTO = {
        contactCenterInteractionId: digitalSessionEvent.Id,
        dynamicsSessionId: sessionId,
        dynamicsinteractionId: result.id_interacao,
      };

      this.localStorageUtils.safeSetItem(
        `sessionRelationship-${sessionData.contactCenterInteractionId}`,
        JSON.stringify(sessionData),
      );
      this.logger.info(
        this.loggerTag + '- fluxo de ticket executado com sucesso',
        result,
      );
    } catch (error) {
      this.eventHandler.remove({ id: digitalSessionEvent.Id, status: '' });
      this.logger.error('- Erro ao processar contato de digital: ', error);
    }
  }

  private async OnDigitalSessionEnded(
    digitalSessionEvent: DigitalSessionEventDTO,
  ) {
    const sessionRelationship = this.localStorageUtils.safeGetItem(
      `sessionRelationship-${digitalSessionEvent.Id}`,
    );

    if (sessionRelationship != null) {
      let sessionRelationshipJSON =
        this.jsonConverterUtils.JsonParsed(sessionRelationship);
      const sessionId = sessionRelationshipJSON.dynamicsSessionId;

      const context = {
        itau_cliente_on: false,
        itau_sessao_ativa: false,
      };

      this.logger.info(this.loggerTag + '- encerrando sessão', sessionId);

      await this.dynamics.cifCloseSession(
        this.channelProviderVariables?.templateAusente ?? '',
        context,
        sessionId,
        digitalSessionEvent.Id,
        digitalSessionEvent.mediaType,
      );
    }
  }
}
